import { render, staticRenderFns } from "./UserAccountDetailsBasicInformation.vue?vue&type=template&id=d4ac6604&"
import script from "./UserAccountDetailsBasicInformation.vue?vue&type=script&lang=js&"
export * from "./UserAccountDetailsBasicInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports